export default "__VITE_ASSET__BAWylRyI__"